import React from 'react';
import { LocalizedStrings } from '@src/utils/localizedStrings';
import { ActionButton, ActionProps } from '../../../../components/ActionButton';

export function GetPasswordLinkButton(props: ActionProps) {
  return (
    <ActionButton
      {...props}
    >
      {lang.getPasswordLink}
    </ActionButton>
  );
}

const lang = LocalizedStrings({
  en: {
    getPasswordLink: 'Send me a link',
  },
});
